import { useState, useRef, useEffect } from "react";
import { TbLogout } from "react-icons/tb";
import { FiSidebar } from "react-icons/fi";
import moment from "moment";
const getPeriod = () => {
  const h = moment().hour();
  if (h < 12) return "Morning";
  if (h < 17) return "Afternoon";
  if (h < 21) return "Evening";
  return "Night";
};
const getInitials = (fullName) =>
  fullName
    ? fullName
      .split(" ")
      .map((w) => w[0])
      .join("")
      .toUpperCase()
    : "";


export default function HeaderUser({
  collapsed,
  toggleSidebar,
  userDetails = {},
  onLogout,
}) {


  const [openProfile, setOpenProfile] = useState(false);
  const profileRef = useRef(null);

  const { name = "", email = "" } = userDetails;
  let period = getPeriod();


  useEffect(() => {
    const close = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setOpenProfile(false);
      }
    };

    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <header
      className={`fixed top-0 right-0 h-20 z-30 flex justify-between items-center bg-indigo-700
      border-b md:px-8 px-4 transition-all duration-300
      ${collapsed ? "md:left-20" : "md:left-64"} left-0`}
    >
      {/* LEFT */}
      <div className="flex items-center gap-3">
        {/* MOBILE TOGGLE */}
        <button
          onClick={toggleSidebar}
          className="md:hidden p-2 rounded-lg bg-indigo-600 text-white"
        >
          <FiSidebar size={24} />
        </button>

        <div>
          <h1 className="md:text-xl text-sm text-white font-medium">
            {name ? `Good ${period}, ${name}` : "Welcome"}
          </h1>
          <p className="text-xs text-white/70">{email}</p>
        </div>
      </div>

      {/* PROFILE */}
      <div className="relative" ref={profileRef}>
        <div className="flex items-center">
          <h1 className="md:text-xl text-sm text-white font-medium mx-2">
            {"Admin"}
          </h1>
          <div
            onClick={() => setOpenProfile((p) => !p)}
            className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-indigo-600
          flex items-center justify-center text-white font-semibold text-lg cursor-pointer"
          >
            {getInitials(name)}
          </div>
        </div>

        {openProfile && (
          <div className="absolute right-0 mt-1 w-80 bg-white rounded-2xl shadow-lg border border-gray-300 overflow-hidden z-50">
            {/* User Info */}
            <div className="flex items-center gap-3 px-4 py-5">
              <div className="w-12 h-12 shrink-0 rounded-full bg-indigo-600 text-white flex items-center justify-center font-semibold text-lg">
                {getInitials(name)}
              </div>
              <div>
                <p className="font-semibold textblack">{name}</p>
                <p className="text-sm textlight">{email}</p>
              </div>
            </div>

            <div className="border-t border-gray-300" />
            <button
              onClick={() => {
                setOpenProfile(false);
                onLogout();
              }}
              className="w-full flex items-center gap-4 px-8 py-7 transition hover:bg-gray-100"
            >
              <span className="textblack">
                <TbLogout size={26} />
              </span>
              <p className="text-lg font-medium textblack">Logout</p>
            </button>
          </div>
        )}
      </div>
    </header>
  );
}